import React, {useState} from 'react';
import {Box, TextField} from '@mui/material';
import {ShortTextQuestion} from 'crqlar-react-common/dist/models/forms/form';
import EditableTypography from 'crqlar-react-common/dist/components/EditableTypography';
import MdEditor from 'crqlar-react-common/dist/components/MdEditor';
import {useTranslation} from 'react-i18next';

interface ShortTextEditorProps {
    question: ShortTextQuestion;
    onQuestionUpdate: (question: ShortTextQuestion) => void;
}

const ShortTextEditor: React.FC<ShortTextEditorProps> = ({
                                                             question,
                                                             onQuestionUpdate
                                                         }) => {
    const {t} = useTranslation();
    const [isEditingPlaceholder, setIsEditingPlaceholder] = useState(false);

    // Handle title update
    const handleTitleUpdate = (title: string) => {
        onQuestionUpdate({
            ...question,
            title
        });
    };

    // Handle description update
    const handleDescriptionUpdate = (description?: string) => {
        onQuestionUpdate({
            ...question,
            description: description || ''
        });
    };

    // Handle placeholder update
    const handlePlaceholderUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
        onQuestionUpdate({
            ...question,
            placeholder: e.target.value,
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                p: 2,
            }}
        >
            {/* Title */}
            <EditableTypography
                value={question.title}
                onChange={handleTitleUpdate}
                multiline
                variant="h6"
                sx={{
                    mb: 2,
                    width: '100%',
                    fontWeight: 'medium',
                    textAlign: 'left',
                    padding: '8px',
                    borderRadius: 1,
                }}
                placeholder={t('Short question here')}
            />

            {/* Description */}
            <Box sx={{mb: 3, width: '100%'}}>
                <MdEditor
                    value={question.description || ''}
                    onChange={handleDescriptionUpdate}
                    placeholder={t('Question description (optional)')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Text Input Field */}
            <Box
                sx={{width: '100%'}}
                onMouseEnter={() => setIsEditingPlaceholder(true)}
                onMouseLeave={() => setIsEditingPlaceholder(false)}
            >
                {isEditingPlaceholder ? (
                    <TextField
                        value={question.placeholder || ''}
                        onChange={handlePlaceholderUpdate}
                        variant="outlined"
                        fullWidth
                        label={t('Placeholder text')}
                        autoFocus
                        sx={{borderRadius: 1}}
                    />
                ) : (
                    <TextField
                        disabled
                        value={question.placeholder || t('Type your answer here...')}
                        variant="outlined"
                        fullWidth
                        sx={{
                            cursor: 'pointer',
                            borderRadius: 1,
                        }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default ShortTextEditor;
